<template>
    <b-modal title="Add Vehicle" v-model="modalVisible" @ok="create" ok-title="Create Vehicle">
        <b-form role="form">          
            <b-form-group id="name-group" label="Name" label-for="input-name">
                <b-form-input
                    type="text"
                    id="input-name"
                    v-model="model.name"
                    required
                    placeholder="Enter Name"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="registration-group"
                label="Registration"
                label-for="input-registration"
            >
                <b-form-input
                    type="text"
                    id="input-registration"
                    v-model="model.registration"
                    required
                    placeholder="Enter Registration"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="model-group"
                label="Model"
                label-for="input-model"
            >
                <b-form-input
                    type="text"
                    id="input-model"
                    v-model="model.model"
                    required
                    placeholder="Enter Model"
                    trim
                ></b-form-input>
            </b-form-group>

            <b-form-group
                id="description-group"
                label="Description"
                label-for="input-description"
            >
                <b-form-textarea
                    id="input-description"
                    v-model="model.description"
                    placeholder="Enter Description"
                    rows="3"
                ></b-form-textarea>
            </b-form-group>

            <b-form-group
                id="color-group"
                label="Color"
                label-for="input-color"
            >
                <b-form-input
                    type="color"
                    id="input-color"
                    v-model="model.color"
                    placeholder="Enter Color"
                ></b-form-input>
            </b-form-group>
        </b-form>
    </b-modal>
</template>

<script>
export default {
    name: 'create-vehicle-form',
    props: [],
    data: () => {
        return {
            modalVisible: false,
            model: {
                name: '',
                registration: '',
                make: '',
                model: '',
                description: '',
                color: '#efefef',
                active: '',
            },
            submitting: false,
            hasErrors: false,
        }
    },
    methods: {
        showModal() {
            this.modalVisible = true
        },

        create() {
            this.$validator.validate().then(valid => {
                if (valid) {
                    this.submitting = true
                    this.$store
                        .dispatch('fleet/create', this.model)
                        .then(() => {
                            this.model = {
                                name: '',
                                registration: '',
                                make: '',
                                model: '',
                                description: '',
                                color: '#efefef',
                                active: '',
                            }
                            this.submitting = false
                            this.$emit('success')
                        })
                        .catch(() => {})
                        .finally(() => {
                            this.submitting = false
                        })
                } else {
                    this.submitting = false
                }
            })
        },
    },
}
</script>
